import { createSlotsContext } from "@grandvisionhq/slots";
const [LineItemSlotsProvider, useLineItemSlots] = createSlotsContext({
  displayName: "LineItemSlotsContext"
});
export {
  LineItemSlotsProvider,
  useLineItemSlots
};
//# sourceMappingURL=context.js.map
